import React, { useState } from 'react';
import { useNavigate }     from 'react-router-dom';
import { login }           from '../api/auth';
import { useAuth }         from '../contexts/AuthContext';
import CurvedText          from '../components/CurvedText';
import './LoginPage.css';

export default function LoginPage() {
  const navigate          = useNavigate();
  const { signIn }        = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await login(username, password);
      if (res.success) {
        signIn(res.data.user, res.data.token);
        navigate('/dashboard');
      } else {
        setError(res.message || 'Login failed');
      }
    } catch (err) {
      setError(
        err.response?.data?.message || 'Unable to connect to server'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-root">

      {/* Full-page background */}
      <div className="login-bg" />

      <div className="login-center">

        {/* Curved "CLASSIC CAR RESTORATION" arc */}
        <CurvedText />

        {/* Login card */}
        <div className="login-card">

          <div className="login-card-header">
            <span className="login-logo">⚙</span>
            <h1 className="login-title">AutoRestoration</h1>
            <p className="login-subtitle">Your classic build, documented.</p>
          </div>

          <form className="login-form" onSubmit={handleSubmit} noValidate>

            <div className="login-field">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                autoComplete="username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Enter username"
                required
                disabled={loading}
              />
            </div>

            <div className="login-field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                required
                disabled={loading}
              />
            </div>

            {error && (
              <div className="login-error" role="alert">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="login-btn"
              disabled={loading || !username || !password}
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </button>

          </form>

          <div className="login-divider"><span>or</span></div>

          <button
            className="login-signup-btn"
            onClick={() => setError('Sign up coming soon — contact your administrator to request access.')}
          >
            Create Account
          </button>

          <p className="login-footer">
            autorestoration.dsdar.com
          </p>

        </div>
      </div>
    </div>
  );
}
